import React from 'react';
import { Container } from 'react-bootstrap';

const AccessDeny = () => {
    return <Container>
        <p>Access Deny</p>
    </Container>
}

export default AccessDeny;